module.exports = __webpack_public_path__ + "images/application/team/patrick-e67c9a66.jpg";